/**
 * Normalizes en-dash, em-dash, and other dash variants to regular hyphen.
 * Useful for income ranges like "12000000–20000000" → "12000000-20000000".
 */
export function normalizeDashes(value: string): string {
  return value.replace(/[\u2013\u2014\u2015\u2212]/g, '-');
}
